import {action, observable} from "mobx";
import {Transport} from "data/transport";


export class HREmailData {
  @observable initialized = false;
  @observable loading = false;
  @observable sentEmails:ISentEmail[];

  send = (request) => new Promise<void>((resolve, reject) => {
    Transport.POST('/hr/email/send', request)
    .then(action((sentEmail:ISentEmail)=>{
      this.sentEmails.unshift(sentEmail);
      resolve();
    }))
    .catch((err)=>{
      reject(err);
    });
  });

  @action load = () => {
    if (!this.loading) {
      this.loading = true;
      Transport.GET('/hr/sentEmails')
      .then(action((response: ISentEmail[]) => {
        this.sentEmails = response;
        this.initialized = true;
        this.loading = false;
      }))
      .catch((e) => {
        console.log(e);
        this.loading = false;
      });
    }
  }

  constructor() {
    this.load();
  }

}

export interface ISentEmail  {
  _id:string;
  type:string;
  subject:string;
  body:string;
  dateSent:Date;
  sender: IUser;
  recipients: IRecipient[];
}

export interface IRecipient {
  name: string;
  email: string;
}

export interface IUser {
  _id: string;
  firstName: string;
  lastName: string;
  email:string;
}

export type RecipientModeType = 'all'|'user'|'not-solution'|'manual';

export interface IUserSelectorData {
  userSelectorMode: RecipientModeType;
  userSelectorIsValid: boolean;
  userSelectorErrorMessage?: string;
  locationIds?: string[];
  userIds?: string[];
  solutionId?: string;
  manualRecipients?:IRecipient[],
}